import { BeneficiaryFilterStringType } from '@repo/shared/dtos/beneficiary'
import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/select'
import { useMemo, useState } from 'react'

import { FilterFormProps } from './types'

export default function StringFilterForm(props: FilterFormProps<BeneficiaryFilterStringType>) {
  const { filter, onChange, onCancel } = props

  const [form, setForm] = useState<BeneficiaryFilterStringType>(filter)
  const { t } = useT({ keyPrefix: 'beneficiary.filters' })

  const isInvalid = useMemo(() => form.operator === 'contains' && form.value.length === 0, [form])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onCancel()
    onChange(form)
  }

  const handleOperatorChange = (operator: BeneficiaryFilterStringType['operator']) => {
    const baseForm: Partial<BeneficiaryFilterStringType> = { type: form.type, key: form.key }
    switch (operator) {
      case 'contains':
        return setForm({ ...baseForm, operator, value: '' } as BeneficiaryFilterStringType)
      case 'is_null':
      case 'is_not_null':
        return setForm({ ...baseForm, operator } as BeneficiaryFilterStringType)

      default:
        throw new Error('Unsupported operator')
    }
  }

  return (
    <form
      onSubmit={(event) => {
        handleSubmit(event)
      }}
      className="min-w-44 space-y-6"
    >
      <div className="space-y-4">
        <Select value={form.operator} onValueChange={handleOperatorChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select an operator" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="contains">{t('operators.contains')}</SelectItem>
            <SelectItem value="is_null">{t('operators.is_null')}</SelectItem>
            <SelectItem value="is_not_null">{t('operators.is_not_null')}</SelectItem>
          </SelectContent>
        </Select>

        {form.operator === 'contains' && (
          <Input
            type="text"
            value={form.value}
            onChange={(e) => setForm({ ...form, value: e.target.value })}
          />
        )}
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" onClick={onCancel} variant="ghost">
          {t('form.cancelButton')}
        </Button>
        <Button type="submit" disabled={isInvalid}>
          {t('form.applyButton')}
        </Button>
      </div>
    </form>
  )
}
